import { Button, Card, Col, Dropdown, Layout, Menu, Row } from "antd";
import UXStyles from "./UX.module.scss";
import aesthetics from "../../assets/images/Aesthetics.png";
import UxFooter from "../../assets/images/UxFooter.jpg";
import { useTranslation } from "react-i18next";

export const UX = () => {
  const { t } = useTranslation();

  const whiteBlockData = [
    {
      bold: "researchTitle",
      text: "researchDescription"
    },
    {
      bold: "architectureTitle",
      text: "architectureDescription"
    },
    {
      bold: "protoTitle",
      text: "protoDescription"
    },
    {
      bold: "usabilityTitle",
      text: "usabilityDescription"
    },
    {
      bold: "personaTitle",
      text: "personaDescription"
    }
  ];
  const aestheticsData = [
    {
      bold: "visualTitle",
      text: "visualDescription"
    },
    {
      bold: "layOutTitle",
      text: "layOutDescription"
    },
    {
      bold: "interactiveTitle",
      text: "interactiveDescription"
    },
    {
      bold: "accessTitle",
      text: "accessDescription"
    },
    {
      bold: "responsiveTitle",
      text: "responsiveDescription"
    }
  ];

  const synergyData = [
    {
      bold: "consistencyHeader",
      text: "consistencyDescription"
    },
    {
      bold: "loopHeader",
      text: "loopDescription"
    },
    {
      bold: "microHeader",
      text: "microDescription"
    },
    {
      bold: "emotionalHeader",
      text: "emotionalDescription"
    }
  ];
  return (
    <Row>
      <div className={UXStyles.bgMainBlock}>
        <p className={UXStyles.UxTitle}>UI/UX Design</p>
        <p className={UXStyles.UxMainText}>{t("UX.headDescription")}</p>
      </div>
      <div className={UXStyles.bgWhiteBlock}>
        <h2 className={UXStyles.UXVioletTitle}>{t("UX.shapingHeader")}</h2>
        <div className={UXStyles.AdvantageBlock}>
          {whiteBlockData.map((item) => {
            return (
              <p className={UXStyles.advantageText}>
                <span className={UXStyles.BoldText}>
                  {t(`UX.${item.bold}`)}:{" "}
                </span>
                {t(`UX.${item.text}`)}{" "}
              </p>
            );
          })}
        </div>
      </div>
      <div className={UXStyles.aestheticsBlock}>
        <img
          src={aesthetics}
          alt="aesthetics"
          className={UXStyles.AestheticsImg}
        />
        <div className={UXStyles.AdvantageBlock}>
          <h2 className={UXStyles.UXVioletTitle}>{t(`UX.aestheticsTitle`)}</h2>
          <img
            src={aesthetics}
            alt="aesthetics"
            className={UXStyles.AestheticsMobileImg}
          />
          {aestheticsData.map((item) => {
            return (
              <p className={UXStyles.advantageText}>
                <span className={UXStyles.BoldText}>
                  {" "}
                  {t(`UX.${item.bold}`)}:{" "}
                </span>
                {t(`UX.${item.text}`)}:{" "}
              </p>
            );
          })}
        </div>
      </div>
      <div className={UXStyles.synergyBlock}>
        <div className={UXStyles.synergyBlockContent}>
          <h2 className={UXStyles.UXWhiteTitle}>{t(`UX.synergyHeader`)}</h2>
          {synergyData.map((item) => {
            return (
              <p className={UXStyles.advantageText}>
                <span className={UXStyles.BoldText}>
                  {t(`UX.${item.bold}`)}:{" "}
                </span>
                {t(`UX.${item.text}`)}
              </p>
            );
          })}
        </div>
      </div>
      <div className={UXStyles.dots}>
        <div className={UXStyles.dot}></div>
        <div className={UXStyles.dot}></div>
        <div className={UXStyles.dot}></div>
        <div className={UXStyles.dot}></div>
        <div className={UXStyles.dot}></div>
      </div>
      <div className={UXStyles.footer}>
        <img src={UxFooter} alt="ux-footer" className={UXStyles.imgFooter} />
        <p className={UXStyles.footerText}>{t(`UX.footer`)}</p>
      </div>
    </Row>
  );
};
